export default "<router-outlet name=\"slideout\" id=\"slideout\"></router-outlet>\n"